import ApiService from '@/services/api.service';

const PatientPortalAssignedNoteService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalAssignedNotes/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalAssignedNotes/${id}`);
    },

    add(data) {
        return ApiService.post(`/PatientPortalAssignedNotes`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortalAssignedNotes/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalAssignedNotes/${id}`, data);
    }
};

export default PatientPortalAssignedNoteService;
